$(() => {
  $(".bs-section--home-member-services .bs-card__title").on("click", (e) => {
    const windowWidth = $(window).width();
    if (windowWidth < 767) {
      $(".bs-section--home-member-services .bs-card__description").not($(e.currentTarget).next()).slideUp();
      $(e.currentTarget).next().slideToggle();
    }
  });

  $(".bs-section--common-tab-slider-accordion-mobile .title-contents").on("click", (e) => {
    $(".bs-section--common-tab-slider-accordion-mobile .wrap-image-content").not($(e.currentTarget).next()).slideUp();
    $(e.currentTarget).next().slideToggle().addClass("show");
  });

  $(".bs-section--processors-data-insights h3").on("click", (e) => {
    const windowWidth = $(window).width();
    if (windowWidth < 767) {
      $(".bs-section--processors-data-insights .bs-div--single-post-block-wrapper").not($(e.currentTarget).next()).slideUp();
      $(e.currentTarget).next().slideToggle();
    }
  });

  $(".bs-section--why-join-three-block").each((index, element) => {
    $(element).find(".bs-div--three-block-common").first().addClass("active");
  });

  $(".bs-section--why-join-three-block h5").on("click", (e) => {
    const windowWidth = $(window).width(),
      parentRow = $(e.currentTarget).parents("section");
    if (windowWidth <= 992) {
      parentRow.find(".bs-div--why-join-block").not($(e.currentTarget).next()).slideUp();
      parentRow.find(".bs-div--three-block-common").removeClass("active");
      $(e.currentTarget).next().slideToggle();
      $(e.currentTarget).parents(".bs-div--three-block-common").toggleClass("active");
    }
  });
});
